import { ActionButtonProps, Box, BoxProps, ColorOptions, Form } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { padZero } from '@jfs/utils'
import { shadow } from 'styled-system'
import { useLazyApiData, useStores } from '../../data/store'
import { formData } from './formData'
export const monthsArray = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const FinHubReports = () => {
  const { downloadFinhubReport } = useStores((store) => ({
    downloadFinhubReport: store.generateExcelFile.downloadFinhubReport,
    //getGenerateFinHubReportReq
  }))

  const [lazyDdwnloadFinhubReport, lazyDownloadFinhubReportHandler] = useLazyApiData(downloadFinhubReport)
  const downloadReport = (values: { months: string; year: string }) => {
    lazyDdwnloadFinhubReport(padZero(monthsArray.indexOf(values.months) + 1), values.year)
  }

  console.log(lazyDownloadFinhubReportHandler.state)

  const actionButtons = ({ values, defaultActionButtonOnSubmit }: ActionButtonProps) => {
    console.log(values)
    return (
      <Box align="center" p={16}>
        <ButtonNew
          title={'Download'}
          onPress={() => downloadReport(values)}
          height={40}
          textType={'bodyMedium14'}
          disabled={!values?.months || !values?.year}
          isLoading={lazyDownloadFinhubReportHandler.state === 'pending'}
        />
      </Box>
    )
  }
  return (
    <Box {...styles.container} p={16}>
      <Form formData={formData() as any} actionButtons={actionButtons} container={FormBox} />
    </Box>
  )
}

const FormBox = ({ children }: any) => <Box>{children}</Box>

const styles = {
  container: {
    borderWidth: 1,
    borderTopWidth: 0,
    borderRadius: 4,
    backgroundColor: 'WHITE',
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
  header: {
    ...shadow,
    marginTop: 16,
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: 14,
    borderWidth: 1,
    borderRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
}

export default FinHubReports
